import { apiConstructor as api } from '@/api/apiConstructor';
import { Block, BlockEditorState, BlocksState } from '@/types/block';
import { AxiosResponse } from 'axios';

export async function getBlocks(): Promise<BlocksState> {
  try {
    const response: AxiosResponse = await api.get('blocks');
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getBlock(id: string): Promise<Block> {
  try {
    const response: AxiosResponse = await api.get(`blocks/${id}`);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function saveBlock(block: BlockEditorState): Promise<Block> {
  const url: string = block.id === null ? 'blocks' : `blocks/${block.id}`;

  const response: AxiosResponse =
    block.id === null
      ? await api.post(url, { ...block })
      : await api.put(url, { ...block });
  return response.data;
}
